// SPDX-FileCopyrightText: Copyright 2026 OP Pohjola (https://op.fi). All Rights Reserved.
// SPDX-License-Identifier: LicenseRef-OpPohjolaAllRightsReserved

import React, { useCallback, useRef, useState } from 'react';
import _ from 'lodash';
import { LoginType, LoginUiPhase, Mode, RepMode } from './constants';
import { useModel } from './ModelProvider';

/* This is the initial state when page is first loaded */

export function initialState(model) {
    const locale = (document.documentElement.getAttribute('lang') || 'fi').substring(0, 2).toLowerCase();
    return {
        mode: model.loginType === LoginType.OPLOGIN ? Mode.LOGIN : Mode.REP,
        lang: locale,
        errorCode: null,
        authType: null,
        loginUiPhase: LoginUiPhase.CREDENTIALS,
        repMode: model.loginType === LoginType.CHANGEREP ? RepMode.CHANGE_REP_INIT : RepMode.AUTO_SELECT,
        representations: null,
        messages: null,
        statusMessage: '',
        errorDisplayed: false,
        currentAuthLevel: model.authLevelAtPageLoad,
    };
}

/* This context provides readable state for every component */
export const StateContext = React.createContext(null);

/* This context provides a function to update state for every component */
export const ChangeStateContext = React.createContext(null);

export const StateContextProvider = (props) => {
    const modelCtx = useModel();

    /* Fullpagelogin master state is stored here */
    const [state, setState] = useState(initialState(modelCtx.model));

    /* Hold state in variable to support multiple changeState calls during one render */
    const currentState = useRef(state);

    /* This function is used by child elements to change app state */
    const changeState = useCallback((input) => {
        currentState.current = _.merge({}, currentState.current, input);
        console.debug('context state was updated', currentState.current);
        setState(currentState.current);
    }, []);

    return (
        <StateContext.Provider value={state}>
            <ChangeStateContext.Provider value={changeState}>{props.children}</ChangeStateContext.Provider>
        </StateContext.Provider>
    );
};
